const BLOCK_TAGS = new Set(['ADDRESS', 'ARTICLE', 'BLOCKQUOTE', 'DIV', 'FOOTER', 'H1', 'H2', 'H3', 'H4',
    'H5', 'H6', 'HEADER', 'HR', 'LI', 'MAIN', 'OL', 'P', 'PRE', 'SECTION', 'TABLE', 'TR', 'UL']);
const INERT_TAGS = new Set(['HEAD', 'IFRAME', 'META', 'NOSCRIPT', 'SCRIPT', 'STYLE', 'TEMPLATE', 'TEXTAREA', 'TITLE']);

// eslint-disable-next-line import/prefer-default-export
export const readableCandidateText = (
    root: HTMLElement,
    visibility?: (element: HTMLElement) => { skipSubtree: boolean; skipText: boolean },
): string => {
    const chunks: string[] = [];
    const visit = (node: Node, parentTextHidden = false): void => {
        if (node.nodeType === Node.TEXT_NODE) {
            if (!parentTextHidden) chunks.push(node.textContent || '');
            return;
        }
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        const element = node as HTMLElement;
        if (INERT_TAGS.has(element.tagName)) return;
        const computed = visibility?.(element);
        if (computed?.skipSubtree) return;
        if (!visibility && element !== root && (element.hidden || element.style.display === 'none'
            || element.style.opacity === '0')) return;
        const textHidden = computed?.skipText ?? (element.style.visibility === 'hidden' || parentTextHidden);
        if (element.tagName === 'BR') {
            chunks.push('\n');
            return;
        }
        if (element.tagName === 'IMG') {
            const alt = element.getAttribute('alt');
            if (alt && !textHidden) chunks.push(`[${alt}]`);
        }
        if (BLOCK_TAGS.has(element.tagName)) chunks.push('\n');
        element.childNodes.forEach((child) => visit(child, textHidden));
        if (BLOCK_TAGS.has(element.tagName)) chunks.push('\n');
        if (element.tagName === 'TD' || element.tagName === 'TH') chunks.push('\t');
    };
    visit(root);
    return chunks.join('').replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
};
